import { createSlice } from '@reduxjs/toolkit';
import { fetchResidueTrace, fetchResidueMovements } from './thunk';

export const initialState = {
	trace: null,
	traceLoading: false,
	traceError: null,
	movements: [],
	movementsLoading: false,
	movementsError: null,
	movementsLoaded: false,
};

const residueTraceSlice = createSlice({
	name: 'ResidueTrace',
	initialState,
	reducers: {
		clearResidueTrace: state => {
			state.trace = null;
			state.traceLoading = false;
			state.traceError = null;
			state.movements = [];
			state.movementsLoading = false;
			state.movementsError = null;
			state.movementsLoaded = false;
		},
		invalidateMovements: state => {
			state.movements = [];
			state.movementsLoading = false;
			state.movementsError = null;
			state.movementsLoaded = false;
		},
	},
	extraReducers: builder => {
		builder
			.addCase(fetchResidueTrace.pending, state => {
				state.traceLoading = true;
				state.traceError = null;
			})
			.addCase(fetchResidueTrace.fulfilled, (state, action) => {
				state.traceLoading = false;
				state.trace = action.payload;
			})
			.addCase(fetchResidueTrace.rejected, (state, action) => {
				state.traceLoading = false;
				state.traceError =
					action.error?.message || 'Error al cargar trazabilidad';
			})
			.addCase(fetchResidueMovements.pending, state => {
				state.movementsLoading = true;
				state.movementsError = null;
			})
			.addCase(fetchResidueMovements.fulfilled, (state, action) => {
				state.movementsLoading = false;
				state.movementsLoaded = true;
				const p = action.payload;
				state.movements = Array.isArray(p) ? p : p?.data || [];
			})
			.addCase(fetchResidueMovements.rejected, (state, action) => {
				state.movementsLoading = false;
				state.movementsError =
					action.error?.message || 'Error al cargar movimientos';
			});
	},
});

export const { clearResidueTrace, invalidateMovements } = residueTraceSlice.actions;
export default residueTraceSlice.reducer;
